/**
 * Maps contact data between frontend format and backend API format
 */

/**
 * Convert frontend contact format to backend API format
 * Frontend: { jobTitle, number, company, isVat, address: { address1, town, county } }
 * Backend: { position, phone, company_name, is_vat_registered, address: { address_1, city, state } }
 */
export function mapContactToBackend(contact) {
    const backendContact = {
        name: contact.name || null,
        position: contact.jobTitle || contact.position || null,
        phone: contact.number || contact.phone || null,
        email: contact.email || null,
        company_name: contact.company || contact.company_name || null,
        description: contact.description || null,
        is_bookable: contact.isBookable !== undefined ? contact.isBookable : contact.is_bookable || false,
        is_vat_registered: contact.isVat !== undefined ? contact.isVat : contact.is_vat_registered || false,
        notes: contact.notes || null,
        tags: contact.tags || null,
        address: {
            address_1: contact.address?.address1 || contact.address?.address_1 || null,
            address_2: contact.address?.address2 || contact.address?.address_2 || null,
            city: contact.address?.town || contact.address?.city || null,
            state: contact.address?.county || contact.address?.state || null,
            postcode: contact.address?.postcode || null,
            country: contact.address?.country || null
        }
    };

    // Remove null values to allow backend to use defaults
    Object.keys(backendContact).forEach(key => {
        if (backendContact[key] === null) {
            delete backendContact[key];
        }
    });

    // Clean up address object
    if (backendContact.address) {
        Object.keys(backendContact.address).forEach(key => {
            if (backendContact.address[key] === null || backendContact.address[key] === '') {
                delete backendContact.address[key];
            }
        });
        
        // Remove address object if it's empty
        if (Object.keys(backendContact.address).length === 0) {
            delete backendContact.address;
        }
    }

    return backendContact;
}

/**
 * Convert backend API format to frontend format
 * Backend: { position, phone, company_name, is_vat_registered, address: { address_1, city, state } }
 * Frontend: { jobTitle, number, company, isVat, address: { address1, town, county } }
 */
export function mapContactFromBackend(backendContact) {
    return {
        id: backendContact.id,
        name: backendContact.name || '',
        jobTitle: backendContact.position || '',
        position: backendContact.position || '', // Keep both for compatibility
        number: backendContact.phone || '',
        phone: backendContact.phone || '', // Keep both for compatibility
        email: backendContact.email || '',
        company: backendContact.company_name || '',
        company_name: backendContact.company_name || '', // Keep both for compatibility
        description: backendContact.description || '',
        isBookable: backendContact.is_bookable || false,
        is_bookable: backendContact.is_bookable || false, // Keep both for compatibility
        isVat: backendContact.is_vat_registered || false,
        is_vat_registered: backendContact.is_vat_registered || false, // Keep both for compatibility
        notes: backendContact.notes || '',
        tags: backendContact.tags || [],
        image: backendContact.image_url || backendContact.image || null,
        image_url: backendContact.image_url || backendContact.image || null, // Keep both
        documents: backendContact.documents || [],
        address: backendContact.address ? {
            address1: backendContact.address.address_1 || '',
            address_1: backendContact.address.address_1 || '', // Keep both
            address2: backendContact.address.address_2 || '',
            address_2: backendContact.address.address_2 || '', // Keep both
            town: backendContact.address.city || '',
            city: backendContact.address.city || '', // Keep both
            county: backendContact.address.state || '',
            state: backendContact.address.state || '', // Keep both
            postcode: backendContact.address.postcode || '',
            country: backendContact.address.country || ''
        } : {
            address1: '',
            address2: '',
            town: '',
            county: '',
            postcode: '',
            country: ''
        }
    };
}



